import styled, { css } from 'styled-components'

import { Image, ImageProps } from '../Image'
import { ThemeWrapper } from '../theme'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const FlagIcon = styled(({ active, ...rest }: ImageProps & { active?: boolean }) => (
  <ThemeWrapper>
    <Image {...rest} />
  </ThemeWrapper>
))`
  ${({ active, theme }) =>
    active
      ? css`
          border: 2px solid ${theme.colors.primary};
          border-radius: 2px;
          padding: 2px;
        `
      : css`
          padding: 4px;
        `};
`

export type FlagMapKeys = 'en' | 'id' | 'hi' | 'ms' | 'vi'

export const flagMap: Record<FlagMapKeys, string> = {
  id: 'flagId',
  en: 'flagUs',
  hi: 'flagHi',
  ms: 'flagMs',
  vi: 'flagVi'
}
